import { createSelector } from '@ngrx/store';
export const getSearchAllParams = (store) => {
    return store.searchAllParams;
};
export const getSearchTypes = createSelector(getSearchAllParams, (params) => params.searchTypes);
export const getQueryInput = createSelector(getSearchAllParams, (params) => params.queryInput);
export const getCategoryPageNum = createSelector(getSearchAllParams, (params) => params.searchCategoryPageNum);
